// hooks/useDigilockerFetch.ts
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory } from 'react-router';
import { getDigilockerUrl } from '../redux/actions/digilocker';
import { GetDigilockerUrlResponse } from '../redux/types/digilocker';

type UseDigilockerFetchArgs = {
  applicationId: string;
  token: string;
  role: string;
  referenceId: string;
  origin: string;
  digiLockerConsent: boolean;
  hasXmlId?: boolean;
  notAuthorizedRole?: string;
};

export function useDigilockerFetch({
  applicationId,
  token,
  role,
  referenceId,
  origin,
  digiLockerConsent,
  hasXmlId,
  notAuthorizedRole = 'investor',
}: UseDigilockerFetchArgs) {
  const dispatch = useDispatch();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const [dialogOpen, setDialogOpen] = useState(false);

  async function triggerDigilocker() {
    if (hasXmlId) {
      setDialogOpen(true);
      return;
    }
    setLoading(true);
    try {
      const response = (await dispatch(
        getDigilockerUrl(applicationId, token, digiLockerConsent, referenceId, origin)
      )) as unknown as GetDigilockerUrlResponse;

      if (!response?.uri) return;
      const hasState = new URLSearchParams(response.uri).get('state') !== null;
      hasState
        ? window.open(response.uri, '_blank')
        : history.push('/not-authorized', { role: notAuthorizedRole });
    } catch (error) {
      console.error((error as Error).message);
    } finally {
      setLoading(false);
    }
  }

  return { loading, dialogOpen, setDialogOpen, triggerDigilocker };
}
